<template>
  <div class="dqyxfx-warp">
    <div class="left-content dn-content-bg zt">
      <div class="jhTime">
        <label>计划时间:</label>
        <div class="valueTime">
          <el-date-picker style="width:150px" v-model="value1" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
          <span>-</span>
          <el-date-picker style="width:150px" v-model="value2" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </div>
        <el-button style="height: 30px;line-height: 0px;" type="primary" @click="TimeControlClick">查询</el-button>
      </div>
      <div class="planeContent">
        <nk-table id="table" ref="nkTable" :data="planTable" :noDataTitle="'该时间段暂无数据'" :columns="planColumns" @rowselectChange="rowselectChange" :border="false" :rowselect="true">
        </nk-table>
      </div>
    </div>
    <div class="right-content" style="width:calc(100% - 480px);position: relative;">
      <div class="exports">
        <el-button type="primary" @click="bindExportExc">导出表格</el-button>
      </div>
      <div class="dn-content-bg box1 zt">
        <echarts :echartsData="echartsData" :direction="'top'"></echarts>
      </div>
      <div class="tab-pane">
        <nk-table id="tableOne" :data="reportTable" :noDataTitle="'该时间段暂无数据'" :columns="reportColumns" :border="false" :rowselect="true">
        </nk-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  exportExcel,
} from "@/utils/index.js";
import { findDataByParam } from '@/utils/index.js'
import * as utils from '@/utils/index.js'
import echarts from '../../nygl/pages/echarts.vue'
import handleData from '@/utils/handleData.js'
import dateTool from '@/utils/dateTool'
import NkTable from '@/components/common/NkTable'
import { isNull } from "util";
let vueVm = {
  components: {
    echarts,
    NkTable,
  },
  data () {
    return {
      planTable: [],/* 能源计划 */
      planColumns: [],
      reportTable: [],/* 能源报告 */
      reportColumns: [],/* 能源报告 */
      chartData: [],
      value1: '',
      value2: '',
      codeData: window.baseConfig.collectData,
      planId: null,
      /* 设置最小时间 */
      spanArr: [],/* 合并单元格 */
      position: '',
      ifClick: false,
      isFirst: true,
      selectRow: null
    }
  },
  created () {
    let time = new Date();
    this.value1 = dateTool.format((time), "yyyy-MM-") + '01 00:00:00'
    time.setMonth(time.getMonth() + 1)
    this.value2 = dateTool.format(new Date(time), "yyyy-MM-") + '01 00:00:00'
    this.getData()
  },
  watch: {
    value2 (newVal, oldVal) {
      if (new Date(newVal).getTime() < new Date(this.value1).getTime()) {
        this.$message.warning("结束时间不能小于开始时间")
        this.value2 = ''
        return
      }
    }
  },
  activated () { },
  methods: {
    /* 能源计划表格点击 */
    rowselectChange (row) {
      if (!row) {
        this.echartsData = {}
        this.reportTable = []
        return false;
      }
      this.selectRow = row
      this.planId = row.id
      this.getEcharts()
    },
    timeControlChange () { },
    /* 查询 */
    TimeControlClick () {
      this.value1 = dateTool.format((new Date(this.value1)), "yyyy-MM-dd hh:mm:ss")
      this.value2 = dateTool.format(new Date(this.value2), "yyyy-MM-dd hh:mm:ss")
      this.getData()
    },
    async getData () {
      let vm = this
      let resPlan = await vm.$api.energyPlan.getEnergyPlan(0, vm.value1, vm.value2)
      if (!vm.planId) {
        vm.planId = resPlan.data.length > 0 ? resPlan.data[0].id : null
      }
      let planColumns = [
        {
          prop: 'name',
          label: '能源计划名称',
          show: true,
          align: 'center',
        },
        {
          prop: 'startTime',
          label: '开始时间',
          show: true,
          align: 'center',
        },
        {
          prop: 'timeGranularity',
          label: '计划时间粒度',
          show: true,
          align: 'center',
          formatter: vm.getTime
        }
      ]
      /* 如果是通过计划表格点击事件触犯就不用重刷新了 */
      vm.planColumns = planColumns
      let planTable = resPlan.data
      vm.planTable = planTable
      /* 默认选中第二条 */
      this.$nextTick(() => {
        this.$refs.nkTable.$refs.table.setCurrentRow(planTable[0]);
      })
    },
    /* 获取图表数据跟表格数据 */
    async getEcharts () {
      let vm = this
      let res = await vm.$api.energyPlan.reportEnergyPlan(vm.planId)
      let reportColumns = [
        {
          prop: 'measureName',
          label: '测量点',
          show: true,
          align: 'center',
        },
        {
          prop: 'expressionDisplayName',
          label: '数据项',
          show: true,
          align: 'center'
        },
        {
          prop: 'desiredValue',
          label: '预估值',
          show: true,
          align: 'center',
        },
        {
          prop: 'compare',
          label: '比较范围',
          show: true,
          align: 'center',
          formatter: vm.getCompare
        },
        {
          prop: 'currentValue',
          label: '当前值',
          show: true,
          align: 'center',
        },
      ]
      vm.reportColumns = reportColumns
      res.data.forEach(item => {
        item.desiredValue = !isNull(item.desiredValue) ? Number(item.desiredValue).toFixed(2) : '-'
        item.currentValue = !isNull(item.currentValue) ? Number(item.currentValue).toFixed(2) : '-'
      })
      let reportTable = res.data
      vm.reportTable = reportTable
      let legend = ['预估值', '当前值']
      let obj = {
        legend: legend,
        xData: [],
        unit: '',
        series: [
          {
            data: [],
            type: 'bar',
            name: legend[0],
          },
          {
            data: [],
            type: 'bar',
            name: legend[1],
          },
        ],
      }
      res.data.forEach(item => {
        obj.xData.push(item.measureName + '-' + item.expressionDisplayName),
          obj.series[0].data.push(!isNull(item.desiredValue) ? Number(item.desiredValue).toFixed(2) : '-')
        obj.series[1].data.push(!isNull(item.currentValue) ? Number(item.currentValue).toFixed(2) : '-')
      })
      obj.magicType = true
      this.echartsData = obj
    },
    /* 比较范围 */
    getCompare (row, column, cellValue) {
      if (cellValue == 1) {
        return '大于'
      } else if (cellValue == 2) {
        return '小于'
      }
    },
    /* 获取时间粒度 */
    getTime (row, column, cellValue) {
      if (cellValue == 1) {
        return '月'
      } else if (cellValue == 2) {
        return '年'
      }
    },
    /* 表格导出 */
    bindExportExc () {
      //表格导出
      let name = "定额分析";
      exportExcel("tableOne", this.selectRow.name, this.selectRow.startTime);
    },
  },
  /* 设置单元格样式 */

}
export default vueVm
</script>
<style  scoped lang="scss">
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  width: 480px;
  min-width: 200px;
  margin-right: 14px;
  color: #000;
  text-align: left;
  .jhTime {
    margin: 10px 5px;
    display: flex;
    align-items: center;
    .valueTime {
      margin: 0 10px;
    }
  }
  .planeContent {
    height: calc(100% - 64px);
  }
}
.right-content {
  height: 100%;
  display: flex;
  flex-flow: column;
}
.box1 {
  height: 70%;
  margin-bottom: 14px;
  .echarts {
    height: 100%;
    width: 100%;
  }
}
.tab-pane {
  width: 100%;
  height: calc(30% - 14px);
  border-radius: 4px;
}
.exports {
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  z-index: 10000;
  height: 40px;
  line-height: 0px;
}
</style>